import React from 'react';

const SpamFolderReminderModal = ({ isOpen, onClose, mode = 'password' }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black/50 z-[60]" 
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 pointer-events-none">
        <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-2xl relative pointer-events-auto">
          {/* Orange X Button */}
          <button
            onClick={onClose}
            className="absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center text-white font-bold cursor-pointer transition-all duration-200 hover:scale-110"
            style={{
              background: 'linear-gradient(135deg, #f59e0b, #f97316)',
              boxShadow: '0 3px 10px rgba(245, 158, 11, 0.4)',
            }}
          >
            ×
          </button>

          {/* Happy Paws Icon */}
          <div className="text-center mb-4">
            <div className="inline-flex items-center justify-center mb-4">
              <svg className="w-20 h-20" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                <circle cx="28" cy="28" r="26" fill="white" stroke="#10B981" strokeWidth="3"/>
                <image href="/icons/paw-frameless-64.png" x="8" y="8" width="40" height="40" />
              </svg>
            </div>
          </div>

          {/* Title */}
          <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">
            {mode === 'password' ? '📧 Check Your Email' : '📧 Check Your Email'}
          </h3>

          {/* Message */}
          <div className="text-center mb-6">
            <p className="text-gray-700 mb-4 leading-relaxed">
              {mode === 'password' 
                ? 'We\'ve sent a password reset link to your email address.'
                : 'We\'ve sent your username to your email address.'}
            </p>
            
            {/* Spam Folder Reminder */}
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
              <p className="text-amber-800 text-sm font-semibold mb-2">
                📬 Don't forget to check your spam folder!
              </p>
              <p className="text-amber-700 text-xs leading-relaxed">
                Sometimes our emails end up in spam. If you don't see it in your inbox within a few minutes, please check your spam/junk folder.
              </p>
            </div>

            <p className="text-gray-600 text-sm">
              Click the link in the email to {mode === 'password' ? 'reset your password' : 'view your username'}.
            </p>
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white py-3 px-6 rounded-full font-semibold shadow-lg transition-all duration-300 transform hover:scale-105"
          >
            Got It!
          </button>
        </div>
      </div>
    </>
  );
};

export default SpamFolderReminderModal;
